import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, CardHeader, Button, Col, Row, Label } from 'reactstrap';
import './styleDashboard.css';
import { Dialog } from 'primereact/dialog';

export const ModalCheckDelivery = (props) => {
    const {
        modalCheckDelivery: modal, toggleCheckDelivery: toggle, changeEstatus, idWorkOrder, commentPatient,
    } = props;

    const comments = Array.isArray(commentPatient)
        ? commentPatient.filter((comment) => comment.id_work_order !== undefined && comment.id_work_order !== null)
        : [{ comment_patient: commentPatient, id_work_order: idWorkOrder }];

    const comment = comments.find((patient) => patient.id_work_order === idWorkOrder)?.comment_patient || '';

    const [localComment, setLocalComment] = useState(comment);

    useEffect(() => {
        setLocalComment(comment);
    }, [comment]);

    const handleContinue = (e) => {
        e.preventDefault();
        changeEstatus(idWorkOrder, localComment);
    };

      const footerTemplate = (
        <div className="text-right">
            <Button size="sm" outline color="primary" type="button" onClick={handleContinue}>
                Sí, continuar
            </Button>{' '}
            <Button size="sm" outline color="danger" type="button" onClick={toggle}>
                Cancelar
            </Button>
        </div>
    );

    return (
         <Dialog
            header="Atención"
            visible={modal}
            modal
            closable={true}
            onHide={toggle}
            className="tiny-dialog"
            dismissableMask={false}
            blockScroll
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
            }}
            footer={footerTemplate}
        >
            <div className="p-2">
                <h6 className="text-center">
                    ¿Estás seguro de que deseas proceder con la entrega?
                </h6>
                <p className="text-center">
                    Ten en cuenta que al realizar esta acción, se desactivará la opción de impresión.
                </p>

                <div className="mt-3">
                    <label className="f-w-600 f-12 badge badge-light-primary">
                        Comentario del Paciente
                    </label>
                    <textarea
                        name="comment"
                        className="form-control form-control-sm input-air-primary"
                        rows={2}
                        value={localComment}
                        onChange={(e) => setLocalComment(e.target.value)}
                        autoComplete="off"
                    />
                </div>
            </div>
        </Dialog>
    );
};
